export default "<footer class=\"global-footer\">\r\n</footer>\r\n";